import React, { useCallback, useContext, useEffect, useState } from 'react';

import ExpenseEntryDialog from '@totem/components/ticketing/details/expenses/expenseEntryDialog';
import ExpensesTable from '@totem/components/ticketing/details/expenses/expensesTable';
import TicketContext from '@totem/components/ticketing/details/ticketContext';
import { Expense } from '@totem/components/ticketing/ticketing';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { isNotNull } from '@totem/utilities/common';
import { TICKET_ENDPOINT } from '@totem/utilities/endpoints';
import { CheckResponseShowError } from '@totem/utilities/responseUtilities';
type Props = {
  expenses: Expense[];
};
const ExpensesSection = ({ expenses }: Props) => {
  const { getApiToken } = useContext(UserProfileContext);
  const { ticket, action, actionExtras, onAction } = useContext(TicketContext);
  const [isSending, setIsSending] = useState(false);
  const deleteExpense = useCallback(
    async (paramTicketId: string, paramExpenseId: string) => {
      if (!isSending) {
        setIsSending(true);

        fetch(
          `${TICKET_ENDPOINT}/${paramTicketId}/expenses/${paramExpenseId}`,
          {
            method: 'DELETE',
            headers: new Headers({
              Authorization: `Bearer ${getApiToken()}`,
            }),
          },
        ).then((res) => {
          setIsSending(false);
          const success = CheckResponseShowError(res);
          if (success) {
            onAction('refresh', '');
          }
        });
      }
    }, // End async
    [],
  );
  useEffect(() => {
    if (
      !isSending &&
      action === 'delete-expense-entry' &&
      typeof actionExtras === 'string' &&
      actionExtras !== ''
    ) {
      // Send Delete
      deleteExpense(ticket.ticket.id, actionExtras);
    }
  }, [action, actionExtras, getApiToken]);
  return (
    <>
      <ExpensesTable expenses={expenses} />
      {action === 'show-expense-entry' &&
        isNotNull(ticket) &&
        isNotNull(ticket.ticket) && <ExpenseEntryDialog />}
    </>
  );
};
export default ExpensesSection;
